export const getIsMobile = (isCompleteRegistrationFlow = false): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const firstName = urlParams.get('firstName');
  const lastName = urlParams.get('lastName');
  const email = urlParams.get('email');
  const phoneCode = urlParams.get('phoneCode');
  const phoneNumber = urlParams.get('phoneNumber');
  const mobileRegistration = urlParams.get('mobileRegistration');

  if (isCompleteRegistrationFlow) {
    return !!mobileRegistration;
  }

  return !!(
    firstName &&
    lastName &&
    email &&
    phoneCode &&
    phoneNumber &&
    mobileRegistration
  );
};

export const getMobileFieldValues = (isMobile?: boolean) => {
  let firstNameMobile: string | null | undefined;
  let lastNameMobile: string | null | undefined;
  let emailMobile;
  let phoneNumberMobile;
  let passwordMobile;
  let phoneCodeMobile;
  if (isMobile) {
    const urlParams = new URLSearchParams(window.location.search);
    firstNameMobile = urlParams.get('firstName');
    lastNameMobile = urlParams.get('lastName');
    emailMobile = urlParams.get('email');
    phoneNumberMobile = urlParams.get('phoneNumber');
    phoneCodeMobile = urlParams.get('phoneCode');
    passwordMobile = urlParams.get('password');
  }

  return {
    firstNameMobile,
    lastNameMobile,
    emailMobile,
    phoneNumberMobile,
    phoneCodeMobile,
    passwordMobile,
  };
};
